import { createContext, useContext } from "react"
import type { NavigationBadgeType } from "./navigation-badge"

// =============================================================================
// Context
// =============================================================================

export type NavigationGroupContextValue = {
  /**
   * Badge type set on the enclosing `Navigation.Group`, if any. `Navigation.GroupItem`
   * children read this to inherit the parent's paid/beta status for tooltips.
   */
  inheritedBadge: NavigationBadgeType | undefined
}

export const NavigationGroupContext =
  createContext<NavigationGroupContextValue>({
    inheritedBadge: undefined
  })

export function useNavigationGroupContext(): NavigationGroupContextValue {
  return useContext(NavigationGroupContext)
}
